// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3lDjP","row":"Node_row__3DLwt","label":"Node_label__18imH","footer":"Node_footer__3_pq2"};